import { Tooltip, Typography } from '@mui/material';
import classNames from 'classnames';
import {
  useState,
  useEffect,
  type Dispatch,
  type SetStateAction,
  type ReactElement,
  useMemo,
} from 'react';

export const OverflowTooltip = ({
  text = '',
  onClick,
  renderContent,
  shouldCloseOnScroll,
}: {
  text: string | undefined;
  onClick?: () => void;
  renderContent?: (
    text: string,

    setTextElementEl: Dispatch<SetStateAction<HTMLElement | null>>
  ) => ReactElement;
  shouldCloseOnScroll?: boolean;
}) => {
  const [textElementEl, setTextElementEl] = useState<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const isOverflowed = useMemo(() => {
    return (
      !!textElementEl && textElementEl.scrollWidth > textElementEl.clientWidth
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textElementEl, text]);

  useEffect(() => {
    if (!shouldCloseOnScroll) return;

    const handleScroll = () => {
      setIsOpen(false);
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [shouldCloseOnScroll]);

  return (
    <Tooltip
      title={isOverflowed ? text : undefined}
      open={shouldCloseOnScroll ? isOpen : undefined}
      onOpen={() => shouldCloseOnScroll && setIsOpen(true)}
      onClose={() => shouldCloseOnScroll && setIsOpen(false)}
    >
      {renderContent ? (
        renderContent(text, setTextElementEl)
      ) : (
        <Typography
          onClick={onClick}
          ref={setTextElementEl}
          component='span'
          className={classNames('truncate', {
            'underline hover:cursor-pointer hover:text-[var(--mui-palette-text-secondary)]':
              onClick,
          })}
        >
          {text}
        </Typography>
      )}
    </Tooltip>
  );
};
